declare interface IStatusSchema {
  remainingItems: number
  totalRemainingOrderStatus: number
  totalTillverkadOrderStatus: number
  totalFelOrderStatus: number
  totalLevereradOrderStatus: number
  totalMonteradOrderStatus: number
}
interface IFloorInterface {
  name: string;
  notes: string;
  cart: String[];
  status: IStatusSchema;
  previousPurchases?: String[];
}
interface IFacadeInterface {
  name: string;
  floors: IFloorInterface[];
  isRoof: string;
}
interface IRoofInterface extends IFloorInterface {
  isRoof: boolean;
}
interface IOtherInterface extends IFloorInterface {
  isOther: boolean;
}
interface IBuildingInterface {
  name: string;
  facades: IFacadeInterface[];
  roofs: IRoofInterface[];
}

interface IConnectedUsers {
  user: string;
  userAccess: string;
}

interface IProjectInterface {
  _id: string;
  name: string;
  owner: string;
  connectedUsers: Array<IConnectedUsers>;
  buildings: IBuildingInterface[];
  others: IOtherInterface[];
  notes: string;
  previousPurchases: Array<string[]>;
  city: string;
  address: string;
  reference: string;
  client: string;
  portcode?: string;
  apartmentnumber?: string;
  keynumber?: string;
  keyplacement?: string;
  material?: ISheetMaterial[];
  contactPersons: string[];
  price: string;
  isArchive: boolean;
}

class Project {
  private project: IProjectInterface = {
    _id: "",
    name: "",
    owner: "",
    connectedUsers: [],
    buildings: [],
    others: [],
    notes: "",
    previousPurchases: [],
    city: "",
    address: "",
    reference: "",
    client: "",
    contactPersons: [],
    price: "",
    isArchive: false,
    portcode: "",
    apartmentnumber: "",
    keynumber: "",
    keyplacement: "",
    material: []
  };


  private faceds: IFacadeInterface = {
    name: "",
    floors: [],
    isRoof: "",
  };
  private floors: IFloorInterface = {
    name: "",
    notes: "",
    cart: [],
    status: {
      remainingItems: 0,
      totalTillverkadOrderStatus: 0,
      totalRemainingOrderStatus: 0,
      totalFelOrderStatus: 0,
      totalLevereradOrderStatus: 0,
      totalMonteradOrderStatus: 0,
    },
    previousPurchases: [],
  };
  private roofs: IRoofInterface = {
    name: "",
    notes: "",
    cart: [],
    status: {
      remainingItems: 0,
      totalTillverkadOrderStatus: 0,
      totalRemainingOrderStatus: 0,
      totalFelOrderStatus: 0,
      totalLevereradOrderStatus: 0,
      totalMonteradOrderStatus: 0,
    },
    previousPurchases: [],
    isRoof: false,
  };
  private others: IOtherInterface = {
    name: "",
    notes: "",
    cart: [],
    status: {
      remainingItems: 0,
      totalTillverkadOrderStatus: 0,
      totalRemainingOrderStatus: 0,
      totalFelOrderStatus: 0,
      totalLevereradOrderStatus: 0,
      totalMonteradOrderStatus: 0,
    },
    previousPurchases: [],
    isOther: false,
  };

  constructor(project: any) {
    this.project._id = project._id;
    this.project.name = project.name;
    this.project.owner = project.owner._id || null;
    this.project.isArchive = project.isArchive;
    this.project.buildings = project.buildings.map((building: any) => {
      return this.getBuildingsData(building);
    });
    this.project.others = this.getProjectOthersData(project.others);
    this.project.notes = project.notes;
    this.project.previousPurchases = project.previousPurchases;
    this.project.city = project.city;
    this.project.address = project.address;
    this.project.reference = project.reference;
    this.project.client = project.client;
    this.project.portcode = project.portcode;
    this.project.apartmentnumber = project.apartmentnumber;
    this.project.keynumber = project.keynumber;
    this.project.keyplacement = project.keyplacement;
    this.project.material = project.material;
    this.project.price = project.price || null;
    if (project.connectedUsers && project.connectedUsers.length) {
      this.project.connectedUsers = project.connectedUsers.filter((user: any) => user.user).map((user: any) => {
        return {
          user: user.user._id,
          userAccess: user.userAccess._id,
          _id: user._id,
        };
      });
    }
    if (project.contactPersons && project.contactPersons.length) {
      this.project.contactPersons = project.contactPersons.map(
        (person: any) => {
          return person._id;
        }
      );
    }
  }

  private getBuildingsData(buildings: IBuildingInterface) {
    let building: IBuildingInterface = { name: "", facades: [], roofs: [] };
    building.name = buildings.name;
    building.facades = buildings.facades.map((data) => {
      return this.getFacedsData(data);
    });
    building.roofs = buildings.roofs.map((data) => {
      return this.getRoofsData(data);
    });
    return building;
  }

  private getProjectOthersData(others: IOtherInterface[]) {
    others = others.map((data) => {
      return this.getOthersData(data);
    });
    return others;
  }
  // constructor(buildings: IBuildingInterface) {

  // }

  private getFacedsData(data: IFacadeInterface) {
    this.faceds = {
      name: data.name,
      floors: data.floors.map((data) => {
        return this.getFloorsData(data);
      }),
      isRoof: data.isRoof,
    };
    return this.faceds;
  }
  private getFloorsData(data: IFloorInterface) {
    this.floors = {
      name: data.name,
      notes: data.notes,
      status: data.status,
      cart: data.cart.map((item: any) => {
        if (item) {
          if (typeof item === "string") {
            return item;
          } else {
            return item && item._id;
          }
        }
      }),
      previousPurchases:
        (data.previousPurchases &&
          data.previousPurchases.map((item: any) => {
            if (item) {
              if (typeof item === "string") {
                return item;
              } else {
                return item && item._id;
              }
            }
          })) ||
        [],
    };
    return this.floors;
  }
  private getRoofsData(data: IRoofInterface) {
    this.roofs = {
      name: data.name,
      notes: data.notes,
      status: data.status,
      cart: data.cart.map((item: any) => {
        if (item) {
          if (typeof item === "string") {
            return item;
          } else {
            return item && item._id;
          }
        }
      }),
      previousPurchases:
        (data.previousPurchases &&
          data.previousPurchases.map((item: any) => {
            if (item) {
              if (typeof item === "string") {
                return item;
              } else {
                return item && item._id;
              }
            }
          })) ||
        [],
      isRoof: data.isRoof,
    };
    return this.roofs;
  }
  private getOthersData(data: IOtherInterface) {
    this.others = {
      name: data.name,
      notes: data.notes,
      status: data.status,
      cart: data.cart.map((item: any) => {
        if (item) {
          if (typeof item === "string") {
            return item;
          } else {
            return item && item._id;
          }
        }
      }),
      previousPurchases:
        (data.previousPurchases &&
          data.previousPurchases.map((item: any) => {
            if (item) {
              if (typeof item === "string") {
                return item;
              } else {
                return item && item._id;
              }
            }
          })) ||
        [],
      isOther: data.isOther,
    };
    return this.others;
  }

  getProjectData() {
    return this.project;
  }
}

export default Project;
